import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../api';

function formatDuration(seconds) {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

export default function ClipPage() {
  const { clipId } = useParams();
  const navigate = useNavigate();
  const [clip, setClip] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.clip(clipId)
      .then(setClip)
      .catch(() => navigate('/'))
      .finally(() => setLoading(false));
  }, [clipId]);

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (loading) return <div className="loading-screen">Loading...</div>;
  if (!clip) return null;

  if (clip.status !== 'ready') {
    return (
      <div style={{ maxWidth: 600, margin: '80px auto', padding: 24, textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: 16 }}>⏳</div>
        <h2 style={{ marginBottom: 8 }}>Clip is processing...</h2>
        <p style={{ color: '#adadb8' }}>This usually takes under a minute. Refresh the page to check.</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px' }}>
      <div className="video-player" style={{ borderRadius: 12, marginBottom: 16 }}>
        <video
          src={`https://stream.mux.com/${clip.mux_playback_id}.m3u8`}
          controls
          autoPlay
          style={{ width: '100%', height: '100%' }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: 8 }}>{clip.title}</h1>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', color: '#adadb8', fontSize: '0.85rem' }}>
            <button onClick={() => navigate(`/${clip.streamer_username}`)}
              style={{ color: '#D6E9AA', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize: '0.85rem' }}>
              {clip.streamer_display || clip.streamer_username}
            </button>
            <span style={{ textTransform: 'capitalize' }}>{clip.category}</span>
            {clip.duration && <span>⏱ {formatDuration(clip.duration)}</span>}
            <span>👁 {clip.view_count} views</span>
            <span>Clipped by <span style={{ color: '#efeff1' }}>{clip.clipped_by_name || clip.clipped_by}</span></span>
            <span>{new Date(clip.created_at).toLocaleDateString()}</span>
          </div>
          <div style={{ marginTop: 8, fontSize: '0.8rem', color: '#adadb8' }}>
            From: <span style={{ color: '#efeff1' }}>{clip.stream_title}</span>
          </div>
        </div>

        <button className="btn btn-secondary" onClick={copyLink} style={{ flexShrink: 0 }}>
          {copied ? '✓ Copied!' : '🔗 Copy Link'}
        </button>
      </div>
    </div>
  );
}
